import { Injectable } from '@angular/core';
import { InvitationsPage } from '@routes/events/models/invitationlist-model';

@Injectable()
export class InvitationPagingService {
  public page: InvitationsPage = {
    'pageNumber': 0,
    'size': 20,
    'filterModel':  {
        'statusFilter': this.getStatusFilter(),
        'mailStatusFilter': this.getMailStatusFilter(),
        'ticketHolderFilter': null,
        'contactTypeFilter': this.getContactTypeFilter(),
        'searchValue': '',
        'accountOwnerFilter': null,
        'groupFilter': null
    },
    'sortProperty': this.getSortProperty(),
    'sortDirection': this.getSortDirection(),
    'totalElements': 0,
    'totalPages': 0
  };

  public setStatusFilter(value: number) {
    localStorage.setItem('invitationsStatusFilter', value.toString());
  }

  public getStatusFilter(): number {
      let value = parseInt(localStorage.getItem('invitationsStatusFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setMailStatusFilter(value: number) {
    localStorage.setItem('invitationsMailStatusFilter', value.toString());
  }

  public getMailStatusFilter(): number {
      let value = parseInt(localStorage.getItem('invitationsMailStatusFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setContactTypeFilter(value: number) {
    localStorage.setItem('invitationsContactTypeFilter', value.toString());
  }

  public getContactTypeFilter(): number {
      let value = parseInt(localStorage.getItem('invitationsContactTypeFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setSortProperty(value: string) {
    if (value) {
      localStorage.setItem('invitationsSortProperty', value);
    } else {
      localStorage.setItem('invitationsSortProperty', '');
    }
  }

  public getSortProperty(): string {
    let value = localStorage.getItem('invitationsSortProperty');
    if (null === value) {
        value = '';
    }

    return value;
  }

  public setSortDirection(value: string) {
    if (value) {
      localStorage.setItem('invitationsSortDirection', value);
    } else {
      localStorage.setItem('invitationsSortDirection', '');
    }
  }

  public getSortDirection(): string {
    let value = localStorage.getItem('invitationsSortDirection');
    if (null === value) {
        value = '';
    }

    return value;
  }

}
